function debounce(func, waitFor) {
    let timeout = null;
    return (...args)=>{
        if (null !== timeout) clearTimeout(timeout);
        timeout = setTimeout(()=>{
            func(...args);
        }, waitFor);
    };
}
export { debounce };
